import mitt from 'mitt';
import type { Emitter } from 'mitt';
import { createInjection } from '@/lib/createInjection';

type BaseArrivalEventMap = {
  baseArrival: undefined;
};

const { provide, inject } = createInjection<Emitter<BaseArrivalEventMap>>('johaisetsuSagyou/baseArrival');

// 親画面側: イベントチャネルを生成してprovideし、自身が使う参照として返す
export function provideBaseArrivalNotification(): Emitter<BaseArrivalEventMap> {
  const events = mitt<BaseArrivalEventMap>();
  provide(events);
  return events;
}

export function useBaseArrivalNotification(): Emitter<BaseArrivalEventMap> {
  return inject();
}
